import React, { Component } from 'react';
import { connect } from 'react-redux';

import Dim from 'web/components/common/modal/common/Dim';
import { initModal, pushModal } from 'shared/actions/modal.action';

import ReviewModal from 'web/components/reviewModal/ReviewModal';

@connect(
  state => ({
    review: state.shared.customer.review,
    modal: state.shared.modal,
  }),
  { initModal, pushModal },
)
class ReviewContainer extends Component {
  setData = data => {
    this.props.pushModal({
      type: 'ReviewModal',
      data: {
        ...data,
      },
    });
  };

  setIdx = idx => {
    const id = this.props.review[idx].id;
    this.setData({ idx, id });
  };

  componentDidMount() {
    // this.findIndex();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.modal.data.id !== this.props.modal.data.id) {
      this.findIndex();
    }
  }

  findIndex = () => {
    // console.log(`findIndex`);
    const idx = this.props.review.findIndex(
      r => r.id === this.props.modal.data.id,
    );
    const id = this.props.review[idx].id;

    this.setData({ idx, id });
  };

  render() {
    const { review, modal = {} } = this.props;
    const { data = {} } = modal;
    const { idx } = data;

    return (
      <Dim onClick={this.props.initModal}>
        <ReviewModal
          handleClose={this.props.initModal}
          modal={this.props.modal}
          list={review}
          idx={idx}
          setIdx={this.setIdx}
        />
      </Dim>
    );
  }
}

export default ReviewContainer;
